
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.344 12.796l.636.772-.636-.772zm5.75-4.729l-.635-.772.636.772zM13.5 25.75v1h1v-1h-1zm7 0h-1v1h1v-1zm4.155-12.954l.636-.773-.636.773zm-5.75-4.729l.636-.772-.636.772zM9.98 13.568l5.75-4.729-1.27-1.544-5.75 4.728 1.27 1.545zm-.73 1.545a2 2 0 01.73-1.545l-1.27-1.545a4 4 0 00-1.46 3.09h2zm0 8.637v-8.637h-2v8.637h2zm1 1a1 1 0 01-1-1h-2a3 3 0 003 3v-2zm3.25 0h-3.25v2h3.25v-2zm1 1v-5.125h-2v5.125h2zm0-5.125v-2a2 2 0 00-2 2h2zm0 0h5v-2h-5v2zm5 0h2a2 2 0 00-2-2v2zm0 0v5.125h2v-5.125h-2zm4.25 4.125H20.5v2h3.25v-2zm1-1a1 1 0 01-1 1v2a3 3 0 003-3h-2zm0-8.637v8.637h2v-8.637h-2zm-.73-1.545a2 2 0 01.73 1.545h2a4 4 0 00-1.46-3.09l-1.27 1.545zM18.27 8.84l5.75 4.73 1.27-1.546-5.75-4.728-1.27 1.544zm-2.54 0a2 2 0 012.54 0l1.27-1.544a4 4 0 00-5.08 0l1.27 1.544z","fill":"currentColor"}})])
          )
        }
      }
    